import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

import "@fontsource/ibm-plex-sans"

const root = ReactDOM.createRoot(document.getElementById('root'));
window.BASE = "/android_asset"
console.log("v2");
root.render(
	<React.StrictMode>
		<BrowserRouter basename={""}>
				<App/>
		</BrowserRouter>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
